var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
export class PatientConsentOrgSharingViewModel {
    constructor(container) {
        this.listInfo = NOT_LOADED;
        this.patientConsentUIManager = container.patientConsentUIManager;
        this.studyManager = container.studyManager;
    }
    run() {
        void this.loadStudyConsents();
    }
    stop() { }
    async loadStudyConsents() {
        var _a;
        this.listInfo = (_a = (await this.patientConsentUIManager.getOptedInStudyConsentsByOrg())) !== null && _a !== void 0 ? _a : [];
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentOrgSharingViewModel.prototype, "listInfo", void 0);
